import React, { useState, useEffect } from "react";
import SideBar from "../../Components/Sidebar";
import CommunityTop from "../Container/Community/CommunityTop";
import "./Community.css";
import { useDispatch, useSelector } from "react-redux";
import Pageheader from "../Container/PageHeader/Pageheader";
import TopCreators from "./TopCreators";
import Recommendations from "./Recommendations";
import CommunitySearch from "../Container/Community/CommunitySearch";
import ConnectionPage from "../ConnectionPages/ConnectionPage";
import { setValue } from "../../redux/valueSlice";
import PendingConnections from "../ConnectionPages/PendingConnections";
import Alert from "../Container/Alert/Alert"
import ChatModal from "../ChatModal";
import { useLocation } from 'react-router-dom';

const Community = () => {
  const dispatch = useDispatch();
  const info = useSelector((state) => state.info);
  const value = useSelector((state) => state?.value);

  const location = useLocation();
  const [viewAll, setViewAll] = useState(false); // ⬅️ Lifted state

  useEffect(() => {
    if (location.state?.viewAll) {
      setViewAll(true);
    }
  }, [location.state]);

  const handlePageClick = () => {
    dispatch(setValue({ profileSearch: false }))
  }


  return (
    <>
      <div
        className={`theme-bg clr-white height-100 ${info?.show ? "blur-background" : ""
          }`}
        style={{ display: "flex" }}
      >
        <SideBar />
        {/* <div className={`container-fluid overflow-x-none ml-80p height-100 `} */}
        <div className="Page-main-container"
          style={{
            ...(viewAll
              ? { overflowY: 'hidden' }
              : { overflowY: 'auto' })
          }}
        >
          {/* <div className="row"> */}
            {/* <div className="container" style={{ minHeight: "100vh", color: "#fff" }}> */}
              {/* <div> */}
                <Pageheader
                  pageTitle="Community"
                  handlePageClick={handlePageClick}
                  nextPage={value?.profileSearch ? "Community Search" : ""}
                />
              {/* </div> */}
              {/* <div className="community_container"> */}
              <div className="Page-sub-container community-page">
                <CommunityTop />
                <div className="community_connections_container">
                  {value?.profileSearch ? (
                    <CommunitySearch />
                  ) : (
                    !viewAll && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: "2.4vh",
                          width: "100%",
                          transition: "all 0.5s ease",
                          opacity: viewAll ? 0 : 1,
                          filter: viewAll ? "blur(0.5vh)" : "none",
                          visibility: viewAll ? "hidden" : "visible",
                        }}
                      >
                        <Recommendations />
                        <TopCreators width="50%" height="43vh" />
                      </div>
                    )
                  )}
                </div>
                  {!value?.profileSearch &&
                    <ConnectionPage
                      viewAll={viewAll}
                      setViewAll={setViewAll}
                      style={{
                        transition: "transform 0.5s ease, opacity 0.5s ease",
                        transform: viewAll ? "translateY(-10vh)" : "translateY(0)",
                        opacity: viewAll ? 1 : 0,
                        position: "relative",
                        zIndex: viewAll ? 1 : -1,
                      }}
                    />
                  }
              </div>
            {/* </div> */}
          {/* </div> */}
        </div>
      </div>
      <PendingConnections />
      <Alert />
      <ChatModal open={value?.isChatOpen} />
    </>
  );
};

export default Community;
